// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/collapsebtn-toyota.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/collapsebtn-lexus.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
body {
  background-color: #a8aaac!important;
}
.addEditToolbox-toyota {
  border-left: solid #e50000 0.375rem;
  margin-top: 0.375rem !important;
  /* border-bottom: solid 1px #e50000; */
  background-color: white;
  height: 5rem;
  align-items: center;
  width:7.5rem;
  border-radius: 0px 20px 20px 0px;
}
.addEditToolbox-lexus {
  border-left: solid black 0.375rem;
  margin-top: 0.375rem !important;
  border-bottom: solid 1px black;
  background-color: white;
  height: 5rem;
  align-items: center;
  width:7.5rem;
  border-radius: 0px 20px 20px 0px;
}

.btn-expand-collapse {
  position: absolute;
  display: block;
  left: 0px;
  bottom: 0;
  width: 100%;
  padding: 8px 0;
  border-top: solid 1px #666;
  color: grey;
  font-size: 20px;
  text-align: center;
}

.btn-expand-collapse:hover, .btn-expand-collapse:focus {
  background-color: #222;
  color: white;
}

.btn-expand-collapse:active {
  background-color: #111;
}

.navbar-primary-menu, .navbar-primary-menu li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.navbar-primary-menu li a {
  display: block;
  padding: 10px 18px;
  text-align: left;
  border-bottom: solid 1px #444;
  color: #ccc;
}

.navbar-primary-menu li a:hover {
  background-color: #000;
  text-decoration: none;
  color: white;
}

.navbar-primary-menu li a .glyphicon {
  margin-right: 6px;
}

.navbar-primary-menu li a:hover .glyphicon {
  color: orchid;
}

.main-content {
  margin-top: 60px;
  margin-left: 200px;
  padding: 20px;
}

.collapsed+.main-content {
  margin-left: 60px;
}

#wrapper {
  width: 100%;
  height: 400px;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel.carousel-slider {
  position: relative;
  overflow: hidden;
  margin-top: 4rem !important;
}

.toolbox {
  background-color: white;
  height: 5rem;
  align-items: center;
}

.row.toolbox.toyota-toolbox {
  border-left: solid #e50000 0.375rem;
  margin-left: 0rem !important;
  border-bottom: solid 1px #e50000;
  margin-right: 0.375rem !important;

}

.row.toolbox.lexus-toolbox {
  border-left: solid #252525 0.375rem;
  margin-left: 0rem !important;
  border-bottom: solid 1px #252525;
  margin-right: 0.375rem !important;

}

.toyota-toolbox:hover {
  background-color: #e50000;
  color: white;
}

.lexus-toolbox:hover {
  background-color: #252525;
  color: white;
}

.toyota-toolbox:focus {
  background-color: #e50000;
  color: white;
}

.lexus-toolbox:focus {
  background-color: #252525;
  color: white;
}

.carousel .slider-wrapper {
  overflow: hidden;
  margin: auto;
  width: 100%;
  transition: height .15s ease-in;
  margin-left: 0.1rem;
  border-radius: 0px 20px 20px 0px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.carousel .control-dots {
  /* position: absolute; */
  position: inherit !important;
  /* margin:0 0 !important; */
  margin-top:-7px !important; 
  bottom: 0;
  text-align: center;
  width: 100%;
  padding: 5px;
}
.toolbox-toyota .dot.selected{
  background-color:#e50000 !important;
}
.toolbox-lexus .dot.selected{
  background-color:#252525 !important;
}

.nav-link {
  background-color: #FFFFFF ;
  margin-right: 2px !important;
}

.nav-tabs {
  border-bottom: 0px !important;
}

.nav-tabs .nav-item {
  width: 24%;
  text-align: center;
  font-size: 0.81rem;
}

.nav-tabs>li:first-child>a {
  border-top-left-radius: 1.25rem;
}

.nav-tabs>li:last-child>a {
  border-top-right-radius: 1.25rem;
}

.nav-link.active {
  font-weight: bold !important;
  border-bottom-width: 0.2rem !important;
}

.button-lexus {
  background-color: #252525;
  border: none;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 1.25rem;
  padding: 0.590rem 50px;
  height: 2.5rem;
}

.button-toyota {
  background-color: #e50000;
  /* Green */
  border: none;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 1.25rem;
  padding: 0.590rem 50px;
  height: 2.5rem;
}

.buttonCancel-toyota {
  background-color: white;
  border: 1px solid #e50000;
  color: #e50000;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 1.25rem;
  height: 2.5rem;
  padding: 0.590rem 50px;
}

.buttonCancel-lexus {
  background-color: white;
  border: 1px solid #252525;
  color: #252525;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 1.25rem;
  height: 2.5rem;
  padding: 0.590rem 50px;
}

.react-bootstrap-table-sort-order {
  color: #e50000;
}
.last_toolbox {
  border-radius: 0px 0px 20px 0px;
}
.first_toolbox {
  border-radius: 0px 20px 0px 0px;
}

.paddingTab {
  padding-top: 3.8rem;
}

.topRightBorderClass {
  border-top-right-radius: 0.678rem;
}

.topLeftBorderClass {
  border-top-left-radius: 0.678rem;
}

.carousel.carousel-slider .ml-1, .mx-1 {
  margin-left: 0px !important;
}

.carousel.carousel-slider .container-fluid {
  padding: 0px !important;
}

.carousel .control-dots {
  /* bottom: 34rem !important; */
  margin-bottom: -10px !important;
}

.toolbox-toyota .carousel .control-dots li {
  /* background: white; */
  border: solid thin #e50000;
  width: 10px !important;
  height: 10px !important;
}
.toolbox-lexus .carousel .control-dots li {
  /* background: white; */
  border: solid thin #252525;
  width: 10px !important;
  height: 10px !important;
}

.carousel div.row.mt-0.flex-column {
  background-color: #a8aaac;
}

.carousel li.slide {
  background: white;
}

.row.toolbox:hover {
  cursor: pointer;
}

.toolbox-toyota .toolbox_hover {
  background-color: #e50000;
  color: white;
}

.toolbox-lexus .toolbox_hover {
  background-color: #252525;
  color: white;
}

.toolbox_hover {
  background-color: #252525;
  color: white;
}

/* .toolbox_hover-toyota {
  background-color: #e50000;
  color: white;
}

.toolbox_hover-lexus {
  background-color: #252525;
  color: white;
} */

.carousel .toolbox {
  /* width: 115px !important; */
}
.slide.selected {
  background-color:white;
  /* margin-left:0.375rem !important; */
}

.downloadTreeContainer{
  /* padding: 10px; */
}
.downloadTreeContainer div{
font-size: 12px !important;
}



.downloadTree{
  background-color:white !important;

}
div[class^="MuiCollapse-wrapperInner"] {
  background-color: #e6e6e6 !important;  
}

.toolbox_style {
  background-repeat: no-repeat;
  background-position: top;
}

/* hover css using toolbox name */

   .toolbox_foundation_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/FOUNDATION\$icon\$foundation-white*png") !important; 
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_accessories_container:hover {
  /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/ACCESSORIES\$icon\$accessories-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_walk_around_check_container:hover {
  /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/WALK_AROUND_CHECK\$icon\$walkAround-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_maintenance_reminders_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/MAINTENANCE_REMINDERS\$icon\$maintenanceReminder-white*png") !important;
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_fix_it_right_container:hover {
  /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/FIX_IT_RIGHT\$icon\$fixItRight-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_efficiency_container:hover {
  /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/EFFICIENCY\$icon\$efficiency-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_dpok_container:hover {
  /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/DPOK\$icon\$dpok-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_employee_engagement_container:hover {
 /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/EMPLOYEE_EMGAGEMENT\$icon\$employeement_engagement-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_customer_centricity_container:hover {
 /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/CUSTOMER_CENTRICITY\$icon\$customer_centricity-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_toyota_way_container:hover {
  /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/TOYOTA_WAY\$icon\$toyota_way-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_business_sustainability_container:hover {
  /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/BUSINESS_SUSTAINIBILITY\$icon\$business_sustainibility-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}
.toolbox_vehicle_trade_in_container:hover {
 /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/VEHICLE_TRADE_IN\$icon\$vehicleTradeIn-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}
.toolbox_refurbishment_container:hover {
 /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/REFURBISHMENT\$icon\$refurbishment-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}
.toolbox_stock_management_container:hover {
 /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/STOCK_MANAGEMENT\$icon\$stock_management-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}
.toolbox_fundamentals_container:hover {
 /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/FUNDAMENTALS\$icon\$fundamentals-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}
.toolbox_fix_it_right_bnp_container:hover {
 /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/FIX_IT_RIGHT_BnP\$icon\$fixItRight-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}
.toolbox_utilization_and_efficiency_container:hover {
 /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/UTILIZATION_AND_EFFICIENCY\$icon\$utilizationAndEfficiency-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}
.toolbox_customer_experience_container:hover {
 /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/CUSTOMER_EXPERIENCE\$icon\$customerExperience-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}
.toolbox_upselling_opportunities_container:hover {
 /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/UPSELLING_OPPORTUNITIES\$icon\$upsellingOpportunities-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}
.toolbox_managing_capacity_container:hover {
 /* background-image: url("http://localhost:9090/ket/v1/questionnaire/download/MANAGING_CAPACITY\$icon\$managingCapacity-white*png"); */
  background-repeat: no-repeat;
  background-position: top;
}  
.toolbox_foundation, .toolbox_accessories, .toolbox_walkAround, .toolbox_maintenanceReminder, toolbox_fixItRight, .toolbox_efficiency, .toolbox_DPOK {
  height: 20px;
  width: 40px;
  margin-left: 18px !important;
}


/* hover css using key for local */

 
 /* .toolbox_1561631791_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/FOUNDATION\$icon\$foundation-white*png") !important; 
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561631861_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/ACCESSORIES\$icon\$accessories-white*png") !important;
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561632012_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/WALK_AROUND_CHECK\$icon\$walkAround-white*png") !important;
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561632025_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/MAINTENANCE_REMINDERS\$icon\$maintenanceReminder-white*png") !important;
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561632038_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/FIX_IT_RIGHT\$icon\$fixItRight-white*png") !important;
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561633009_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/EFFICIENCY\$icon\$efficiency-white*png") !important;
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561633019_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/DPOK\$icon\$dpok-white*png") !important;
  background-repeat: no-repeat;
  background-position: top;
}



.toolbox_1561633631_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/EMPLOYEE_ENGAGEMENT\$icon\$employee_engagement-white*png") !important;
   background-repeat: no-repeat;
   background-position: top;
 }
 
 .toolbox_1561633036_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/CUSTOMER_CENTRICITY\$icon\$customer_centricity-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 }
 
 .toolbox_1561633055_container:hover {
   background-image: url("http://localhost:9090/ket/v1/questionnaire/download/TOYOTA_WAY\$icon\$toyota_way-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 }
 
 .toolbox_1561633092_container:hover {
   background-image: url("http://localhost:9090/ket/v1/questionnaire/download/BUSINESS_SUSTAINABILITY\$icon\$business_sustainability-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633702_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/VEHICLE_TRADE_IN\$icon\$vehicleTradeIn-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633730_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/REFURBISHMENT\$icon\$refurbishment-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633711_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/STOCK_MANAGEMENT\$icon\$stockManagement-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633100_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/FUNDAMENTALS\$icon\$fundamentals-white*png") !important;
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633642_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/FIX_IT_RIGHT_BnP\$icon\$fixItRight-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633651_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/UTILIZATION_AND_EFFICIENCY\$icon\$utilizationAndEfficiency-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633665_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/CUSTOMER_EXPERIENCE\$icon\$customerExperience-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633674_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/UPSELLING_OPPORTUNITIES\$icon\$upsellingOpportunities-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633683_container:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/MANAGING_CAPACITY\$icon\$managingCapacity-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 } 

 .toolbox_default:hover {
  background-image: url("http://localhost:9090/ket/v1/questionnaire/download/DEFAULT_ICON\$icon\$default-white*png")!important;
   background-repeat: no-repeat;
   background-position: top;
 }  */


 

 /* hover css using key for Dev */
 
  .toolbox_1561631791_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/FOUNDATION\$icon\$foundation-white*png") !important;  */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561631861_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/ACCESSORIES\$icon\$accessories-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561632012_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/WALK_AROUND_CHECK\$icon\$walkAround-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561632025_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/MAINTENANCE_REMINDERS\$icon\$maintenanceReminder-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561632038_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/FIX_IT_RIGHT\$icon\$fixItRight-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561633009_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/EFFICIENCY\$icon\$efficiency-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}

.toolbox_1561633019_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/DPOK\$icon\$dpok-white*png") !important; */
  background-repeat: no-repeat;
  background-position: top;
}



.toolbox_1561633631_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/EMPLOYEE_ENGAGEMENT\$icon\$employee_engagement-white*png") !important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 
 .toolbox_1561633036_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/CUSTOMER_CENTRICITY\$icon\$customer_centricity-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 
 .toolbox_1561633055_container:hover {
   /* background-image: url("/ket/v1/questionnaire/download/TOYOTA_WAY\$icon\$toyota_way-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 
 .toolbox_1561633092_container:hover {
   /* background-image: url("/ket/v1/questionnaire/download/BUSINESS_SUSTAINABILITY\$icon\$business_sustainability-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633702_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/VEHICLE_TRADE_IN\$icon\$vehicleTradeIn-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633730_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/REFURBISHMENT\$icon\$refurbishment-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633711_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/STOCK_MANAGEMENT\$icon\$stockManagement-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633100_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/FUNDAMENTALS\$icon\$fundamentals-white*png") !important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633642_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/FIX_IT_RIGHT_BnP\$icon\$fixItRight-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633651_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/UTILIZATION_AND_EFFICIENCY\$icon\$utilizationAndEfficiency-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633665_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/CUSTOMER_EXPERIENCE\$icon\$customerExperience-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633674_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/UPSELLING_OPPORTUNITIES\$icon\$upsellingOpportunities-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 }
 .toolbox_1561633683_container:hover {
  /* background-image: url("/ket/v1/questionnaire/download/MANAGING_CAPACITY\$icon\$managingCapacity-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 } 

 .toolbox_default:hover {
  /* background-image: url("/ket/v1/questionnaire/download/DEFAULT_ICON\$icon\$default-white*png")!important; */
   background-repeat: no-repeat;
   background-position: top;
 }    

 .toolboxLabel{
  /* background-color: #e50000; */
  margin-bottom:0px;
/*   color:white; */
}



.leftPaneAdd {
  max-width:25%;
  flex:0 0 25%;
  padding-left:8px;
  padding-right:10px;
  min-height: 4rem;
}

.leftPanelContentadd {
  width:94%;
  height:100%;
  display:inline-block;
}

.toogleSwitch-toyota{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: white; 
  height: 100%;
  cursor: pointer;
  width:14px;
  background-repeat: no-repeat;
  /* margin-left:5px; */
  border:solid 1px #ececec;
  background-position: center;
}
.toogleSwitch-lexus{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-color: white; 
  height: 100%;
  cursor: pointer;
  width:14px;
  background-repeat: no-repeat;
  /* margin-left:5px; */
  border:solid 1px #ececec;
  background-position: center;
 
}

.addEditPadding{
  padding-top: 2rem !important;
}
.collapsed{
  padding-top: 2rem !important;
  display: none !important;
}
.collapseAddEdit{
  height: 100%;
  /* padding-left: .4rem; */
}

.addEditToolboxRemove-toyota {
  border-left: solid #e50000 0.375rem;
  /* margin: 0.375rem !important; */
  margin-top: 0.375rem !important;
  height: 5rem;
  align-items: center;
  width:7.5rem;
  border-radius: 0px 20px 20px 0px;
}
.addEditToolboxRemove-lexus {
  border-left: solid black 0.375rem;
  /* margin: 0.375rem !important; */
  margin-top: 0.375rem !important;
  height: 5rem;
  align-items: center;
  width:7.5rem;
  border-radius: 0px 20px 20px 0px;
}

.kpiTableContainer .nav-link{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
/* .container-fluid .libraryContainer .button-toyota{
  bottom: 38px;
  position: absolute;
} */
/* .rightPanel.libRightPanel{
  position:relative; 
} */
.kpiTableContainer.tab-content{
  min-height: 779px;
 }
/* .kpiTableContainer.nmscTable{
  min-height: 779px;
} */
/* .tab-content.nmscTable{
 min-height: 3rem;
} */


.selectField{
  width: 95%;
  margin-bottom: 5%;
}
.selectFieldDisplay{
  width: 95%;
  margin-bottom: 5%;
  display: none
}
.marginTop{
  margin-top: -12% !important;
  margin-right: -1% !important;
}
 
/* .modal {
  display: block !important;
} */`, "",{"version":3,"sources":["webpack://./src/components/toolbox/index.css"],"names":[],"mappings":";AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,sCAAsC;EACtC,uBAAuB;EACvB,YAAY;EAEZ,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EAEZ,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,SAAS;EACT,WAAW;EACX,cAAc;EACd,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gCAAgC;EAChC,iCAAiC;;AAEnC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gCAAgC;EAChC,iCAAiC;;AAEnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EAEX,+BAA+B;EAC/B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;;;;;;;GAQG;;AAEH;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;AACA;AACA,0BAA0B;AAC1B;;;;AAIA;EACE,iCAAiC;;AAEnC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA,iCAAiC;;GAE9B;EACD,4HAA4H;EAC5H,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,oIAAoI;EACpI,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,yIAAyI;EACzI,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,gJAAgJ;EAChJ,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,oIAAoI;EACpI,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,kIAAkI;EAClI,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,sHAAsH;EACtH,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;CACC,wJAAwJ;EACvJ,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;CACC,yIAAyI;EACxI,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,uHAAuH;EACvH,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,iJAAiJ;EACjJ,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;CACC,iIAAiI;EAChI,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;CACC,6HAA6H;EAC5H,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;CACC,mIAAmI;EAClI,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;CACC,2HAA2H;EAC1H,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;CACC,6HAA6H;EAC5H,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;CACC,qJAAqJ;EACpJ,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;CACC,wIAAwI;EACvI,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;CACC,gJAAgJ;EAC/I,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;CACC,oIAAoI;EACnI,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;EACX,4BAA4B;AAC9B;;;AAGA,kCAAkC;;;CAGjC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAqHI;;;;;CAKJ,gCAAgC;;EAE/B;EACA,8GAA8G;EAC9G,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,+GAA+G;EAC/G,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,oHAAoH;EACpH,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,iIAAiI;EACjI,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,+GAA+G;EAC/G,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,6GAA6G;EAC7G,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,iGAAiG;EACjG,4BAA4B;EAC5B,wBAAwB;AAC1B;;;;AAIA;EACE,+HAA+H;GAC9H,4BAA4B;GAC5B,wBAAwB;CAC1B;;CAEA;EACC,8HAA8H;GAC7H,4BAA4B;GAC5B,wBAAwB;CAC1B;;CAEA;GACE,4GAA4G;GAC5G,4BAA4B;GAC5B,wBAAwB;CAC1B;;CAEA;GACE,sIAAsI;GACtI,4BAA4B;GAC5B,wBAAwB;CAC1B;CACA;EACC,sHAAsH;GACrH,4BAA4B;GAC5B,wBAAwB;CAC1B;CACA;EACC,kHAAkH;GACjH,4BAA4B;GAC5B,wBAAwB;CAC1B;CACA;EACC,uHAAuH;GACtH,4BAA4B;GAC5B,wBAAwB;CAC1B;CACA;EACC,iHAAiH;GAChH,4BAA4B;GAC5B,wBAAwB;CAC1B;CACA;EACC,kHAAkH;GACjH,4BAA4B;GAC5B,wBAAwB;CAC1B;CACA;EACC,0IAA0I;GACzI,4BAA4B;GAC5B,wBAAwB;CAC1B;CACA;EACC,6HAA6H;GAC5H,4BAA4B;GAC5B,wBAAwB;CAC1B;CACA;EACC,qIAAqI;GACpI,4BAA4B;GAC5B,wBAAwB;CAC1B;CACA;EACC,yHAAyH;GACxH,4BAA4B;GAC5B,wBAAwB;CAC1B;;CAEA;EACC,2GAA2G;GAC1G,4BAA4B;GAC5B,wBAAwB;CAC1B;;CAEA;EACC,+BAA+B;EAC/B,iBAAiB;AACnB,mBAAmB;AACnB;;;;AAIA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yDAAmE;EACnE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,4BAA4B;EAC5B,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,yDAAkE;EAClE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,4BAA4B;EAC5B,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;;AAE7B;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,+BAA+B;EAC/B,YAAY;EAEZ,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,+BAA+B;EAC/B,YAAY;EAEZ,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;GAGG;AACH;;GAEG;AACH;EACE,iBAAiB;CAClB;AACD;;GAEG;AACH;;GAEG;;;AAGH;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB;AACF;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;GAEG","sourcesContent":["\nbody {\n  background-color: #a8aaac!important;\n}\n.addEditToolbox-toyota {\n  border-left: solid #e50000 0.375rem;\n  margin-top: 0.375rem !important;\n  /* border-bottom: solid 1px #e50000; */\n  background-color: white;\n  height: 5rem;\n  -ms-flex-align: center;\n  align-items: center;\n  width:7.5rem;\n  border-radius: 0px 20px 20px 0px;\n}\n.addEditToolbox-lexus {\n  border-left: solid black 0.375rem;\n  margin-top: 0.375rem !important;\n  border-bottom: solid 1px black;\n  background-color: white;\n  height: 5rem;\n  -ms-flex-align: center;\n  align-items: center;\n  width:7.5rem;\n  border-radius: 0px 20px 20px 0px;\n}\n\n.btn-expand-collapse {\n  position: absolute;\n  display: block;\n  left: 0px;\n  bottom: 0;\n  width: 100%;\n  padding: 8px 0;\n  border-top: solid 1px #666;\n  color: grey;\n  font-size: 20px;\n  text-align: center;\n}\n\n.btn-expand-collapse:hover, .btn-expand-collapse:focus {\n  background-color: #222;\n  color: white;\n}\n\n.btn-expand-collapse:active {\n  background-color: #111;\n}\n\n.navbar-primary-menu, .navbar-primary-menu li {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.navbar-primary-menu li a {\n  display: block;\n  padding: 10px 18px;\n  text-align: left;\n  border-bottom: solid 1px #444;\n  color: #ccc;\n}\n\n.navbar-primary-menu li a:hover {\n  background-color: #000;\n  text-decoration: none;\n  color: white;\n}\n\n.navbar-primary-menu li a .glyphicon {\n  margin-right: 6px;\n}\n\n.navbar-primary-menu li a:hover .glyphicon {\n  color: orchid;\n}\n\n.main-content {\n  margin-top: 60px;\n  margin-left: 200px;\n  padding: 20px;\n}\n\n.collapsed+.main-content {\n  margin-left: 60px;\n}\n\n#wrapper {\n  width: 100%;\n  height: 400px;\n  border: 1px solid black;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.carousel.carousel-slider {\n  position: relative;\n  overflow: hidden;\n  margin-top: 4rem !important;\n}\n\n.toolbox {\n  background-color: white;\n  height: 5rem;\n  align-items: center;\n}\n\n.row.toolbox.toyota-toolbox {\n  border-left: solid #e50000 0.375rem;\n  margin-left: 0rem !important;\n  border-bottom: solid 1px #e50000;\n  margin-right: 0.375rem !important;\n\n}\n\n.row.toolbox.lexus-toolbox {\n  border-left: solid #252525 0.375rem;\n  margin-left: 0rem !important;\n  border-bottom: solid 1px #252525;\n  margin-right: 0.375rem !important;\n\n}\n\n.toyota-toolbox:hover {\n  background-color: #e50000;\n  color: white;\n}\n\n.lexus-toolbox:hover {\n  background-color: #252525;\n  color: white;\n}\n\n.toyota-toolbox:focus {\n  background-color: #e50000;\n  color: white;\n}\n\n.lexus-toolbox:focus {\n  background-color: #252525;\n  color: white;\n}\n\n.carousel .slider-wrapper {\n  overflow: hidden;\n  margin: auto;\n  width: 100%;\n  -webkit-transition: height .15s ease-in;\n  transition: height .15s ease-in;\n  margin-left: 0.1rem;\n  border-radius: 0px 20px 20px 0px;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n\n.carousel .control-dots {\n  /* position: absolute; */\n  position: inherit !important;\n  /* margin:0 0 !important; */\n  margin-top:-7px !important; \n  bottom: 0;\n  text-align: center;\n  width: 100%;\n  padding: 5px;\n}\n.toolbox-toyota .dot.selected{\n  background-color:#e50000 !important;\n}\n.toolbox-lexus .dot.selected{\n  background-color:#252525 !important;\n}\n\n.nav-link {\n  background-color: #FFFFFF ;\n  margin-right: 2px !important;\n}\n\n.nav-tabs {\n  border-bottom: 0px !important;\n}\n\n.nav-tabs .nav-item {\n  width: 24%;\n  text-align: center;\n  font-size: 0.81rem;\n}\n\n.nav-tabs>li:first-child>a {\n  border-top-left-radius: 1.25rem;\n}\n\n.nav-tabs>li:last-child>a {\n  border-top-right-radius: 1.25rem;\n}\n\n.nav-link.active {\n  font-weight: bold !important;\n  border-bottom-width: 0.2rem !important;\n}\n\n.button-lexus {\n  background-color: #252525;\n  border: none;\n  color: white;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  margin: 4px 2px;\n  cursor: pointer;\n  border-radius: 1.25rem;\n  padding: 0.590rem 50px;\n  height: 2.5rem;\n}\n\n.button-toyota {\n  background-color: #e50000;\n  /* Green */\n  border: none;\n  color: white;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  margin: 4px 2px;\n  cursor: pointer;\n  border-radius: 1.25rem;\n  padding: 0.590rem 50px;\n  height: 2.5rem;\n}\n\n.buttonCancel-toyota {\n  background-color: white;\n  border: 1px solid #e50000;\n  color: #e50000;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  margin: 4px 2px;\n  cursor: pointer;\n  border-radius: 1.25rem;\n  height: 2.5rem;\n  padding: 0.590rem 50px;\n}\n\n.buttonCancel-lexus {\n  background-color: white;\n  border: 1px solid #252525;\n  color: #252525;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  margin: 4px 2px;\n  cursor: pointer;\n  border-radius: 1.25rem;\n  height: 2.5rem;\n  padding: 0.590rem 50px;\n}\n\n.react-bootstrap-table-sort-order {\n  color: #e50000;\n}\n.last_toolbox {\n  border-radius: 0px 0px 20px 0px;\n}\n.first_toolbox {\n  border-radius: 0px 20px 0px 0px;\n}\n\n.paddingTab {\n  padding-top: 3.8rem;\n}\n\n.topRightBorderClass {\n  border-top-right-radius: 0.678rem;\n}\n\n.topLeftBorderClass {\n  border-top-left-radius: 0.678rem;\n}\n\n.carousel.carousel-slider .ml-1, .mx-1 {\n  margin-left: 0px !important;\n}\n\n.carousel.carousel-slider .container-fluid {\n  padding: 0px !important;\n}\n\n.carousel .control-dots {\n  /* bottom: 34rem !important; */\n  margin-bottom: -10px !important;\n}\n\n.toolbox-toyota .carousel .control-dots li {\n  /* background: white; */\n  border: solid thin #e50000;\n  width: 10px !important;\n  height: 10px !important;\n}\n.toolbox-lexus .carousel .control-dots li {\n  /* background: white; */\n  border: solid thin #252525;\n  width: 10px !important;\n  height: 10px !important;\n}\n\n.carousel div.row.mt-0.flex-column {\n  background-color: #a8aaac;\n}\n\n.carousel li.slide {\n  background: white;\n}\n\n.row.toolbox:hover {\n  cursor: pointer;\n}\n\n.toolbox-toyota .toolbox_hover {\n  background-color: #e50000;\n  color: white;\n}\n\n.toolbox-lexus .toolbox_hover {\n  background-color: #252525;\n  color: white;\n}\n\n.toolbox_hover {\n  background-color: #252525;\n  color: white;\n}\n\n/* .toolbox_hover-toyota {\n  background-color: #e50000;\n  color: white;\n}\n\n.toolbox_hover-lexus {\n  background-color: #252525;\n  color: white;\n} */\n\n.carousel .toolbox {\n  /* width: 115px !important; */\n}\n.slide.selected {\n  background-color:white;\n  /* margin-left:0.375rem !important; */\n}\n\n.downloadTreeContainer{\n  /* padding: 10px; */\n}\n.downloadTreeContainer div{\nfont-size: 12px !important;\n}\n\n\n\n.downloadTree{\n  background-color:white !important;\n\n}\ndiv[class^=\"MuiCollapse-wrapperInner\"] {\n  background-color: #e6e6e6 !important;  \n}\n\n.toolbox_style {\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n/* hover css using toolbox name */\n\n   .toolbox_foundation_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/FOUNDATION$icon$foundation-white*png\") !important; \n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_accessories_container:hover {\n  /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/ACCESSORIES$icon$accessories-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_walk_around_check_container:hover {\n  /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/WALK_AROUND_CHECK$icon$walkAround-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_maintenance_reminders_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/MAINTENANCE_REMINDERS$icon$maintenanceReminder-white*png\") !important;\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_fix_it_right_container:hover {\n  /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/FIX_IT_RIGHT$icon$fixItRight-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_efficiency_container:hover {\n  /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/EFFICIENCY$icon$efficiency-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_dpok_container:hover {\n  /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/DPOK$icon$dpok-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_employee_engagement_container:hover {\n /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/EMPLOYEE_EMGAGEMENT$icon$employeement_engagement-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_customer_centricity_container:hover {\n /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/CUSTOMER_CENTRICITY$icon$customer_centricity-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_toyota_way_container:hover {\n  /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/TOYOTA_WAY$icon$toyota_way-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_business_sustainability_container:hover {\n  /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/BUSINESS_SUSTAINIBILITY$icon$business_sustainibility-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n.toolbox_vehicle_trade_in_container:hover {\n /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/VEHICLE_TRADE_IN$icon$vehicleTradeIn-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n.toolbox_refurbishment_container:hover {\n /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/REFURBISHMENT$icon$refurbishment-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n.toolbox_stock_management_container:hover {\n /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/STOCK_MANAGEMENT$icon$stock_management-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n.toolbox_fundamentals_container:hover {\n /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/FUNDAMENTALS$icon$fundamentals-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n.toolbox_fix_it_right_bnp_container:hover {\n /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/FIX_IT_RIGHT_BnP$icon$fixItRight-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n.toolbox_utilization_and_efficiency_container:hover {\n /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/UTILIZATION_AND_EFFICIENCY$icon$utilizationAndEfficiency-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n.toolbox_customer_experience_container:hover {\n /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/CUSTOMER_EXPERIENCE$icon$customerExperience-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n.toolbox_upselling_opportunities_container:hover {\n /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/UPSELLING_OPPORTUNITIES$icon$upsellingOpportunities-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n.toolbox_managing_capacity_container:hover {\n /* background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/MANAGING_CAPACITY$icon$managingCapacity-white*png\"); */\n  background-repeat: no-repeat;\n  background-position: top;\n}  \n.toolbox_foundation, .toolbox_accessories, .toolbox_walkAround, .toolbox_maintenanceReminder, toolbox_fixItRight, .toolbox_efficiency, .toolbox_DPOK {\n  height: 20px;\n  width: 40px;\n  margin-left: 18px !important;\n}\n\n\n/* hover css using key for local */\n\n \n /* .toolbox_1561631791_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/FOUNDATION$icon$foundation-white*png\") !important; \n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561631861_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/ACCESSORIES$icon$accessories-white*png\") !important;\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561632012_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/WALK_AROUND_CHECK$icon$walkAround-white*png\") !important;\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561632025_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/MAINTENANCE_REMINDERS$icon$maintenanceReminder-white*png\") !important;\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561632038_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/FIX_IT_RIGHT$icon$fixItRight-white*png\") !important;\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561633009_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/EFFICIENCY$icon$efficiency-white*png\") !important;\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561633019_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/DPOK$icon$dpok-white*png\") !important;\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n\n\n.toolbox_1561633631_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/EMPLOYEE_ENGAGEMENT$icon$employee_engagement-white*png\") !important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n \n .toolbox_1561633036_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/CUSTOMER_CENTRICITY$icon$customer_centricity-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n \n .toolbox_1561633055_container:hover {\n   background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/TOYOTA_WAY$icon$toyota_way-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n \n .toolbox_1561633092_container:hover {\n   background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/BUSINESS_SUSTAINABILITY$icon$business_sustainability-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633702_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/VEHICLE_TRADE_IN$icon$vehicleTradeIn-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633730_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/REFURBISHMENT$icon$refurbishment-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633711_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/STOCK_MANAGEMENT$icon$stockManagement-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633100_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/FUNDAMENTALS$icon$fundamentals-white*png\") !important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633642_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/FIX_IT_RIGHT_BnP$icon$fixItRight-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633651_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/UTILIZATION_AND_EFFICIENCY$icon$utilizationAndEfficiency-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633665_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/CUSTOMER_EXPERIENCE$icon$customerExperience-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633674_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/UPSELLING_OPPORTUNITIES$icon$upsellingOpportunities-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633683_container:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/MANAGING_CAPACITY$icon$managingCapacity-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n } \n\n .toolbox_default:hover {\n  background-image: url(\"http://localhost:9090/ket/v1/questionnaire/download/DEFAULT_ICON$icon$default-white*png\")!important;\n   background-repeat: no-repeat;\n   background-position: top;\n }  */\n\n\n \n\n /* hover css using key for Dev */\n \n  .toolbox_1561631791_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/FOUNDATION$icon$foundation-white*png\") !important;  */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561631861_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/ACCESSORIES$icon$accessories-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561632012_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/WALK_AROUND_CHECK$icon$walkAround-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561632025_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/MAINTENANCE_REMINDERS$icon$maintenanceReminder-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561632038_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/FIX_IT_RIGHT$icon$fixItRight-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561633009_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/EFFICIENCY$icon$efficiency-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n.toolbox_1561633019_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/DPOK$icon$dpok-white*png\") !important; */\n  background-repeat: no-repeat;\n  background-position: top;\n}\n\n\n\n.toolbox_1561633631_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/EMPLOYEE_ENGAGEMENT$icon$employee_engagement-white*png\") !important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n \n .toolbox_1561633036_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/CUSTOMER_CENTRICITY$icon$customer_centricity-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n \n .toolbox_1561633055_container:hover {\n   /* background-image: url(\"/ket/v1/questionnaire/download/TOYOTA_WAY$icon$toyota_way-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n \n .toolbox_1561633092_container:hover {\n   /* background-image: url(\"/ket/v1/questionnaire/download/BUSINESS_SUSTAINABILITY$icon$business_sustainability-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633702_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/VEHICLE_TRADE_IN$icon$vehicleTradeIn-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633730_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/REFURBISHMENT$icon$refurbishment-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633711_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/STOCK_MANAGEMENT$icon$stockManagement-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633100_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/FUNDAMENTALS$icon$fundamentals-white*png\") !important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633642_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/FIX_IT_RIGHT_BnP$icon$fixItRight-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633651_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/UTILIZATION_AND_EFFICIENCY$icon$utilizationAndEfficiency-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633665_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/CUSTOMER_EXPERIENCE$icon$customerExperience-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633674_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/UPSELLING_OPPORTUNITIES$icon$upsellingOpportunities-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }\n .toolbox_1561633683_container:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/MANAGING_CAPACITY$icon$managingCapacity-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n } \n\n .toolbox_default:hover {\n  /* background-image: url(\"/ket/v1/questionnaire/download/DEFAULT_ICON$icon$default-white*png\")!important; */\n   background-repeat: no-repeat;\n   background-position: top;\n }    \n\n .toolboxLabel{\n  /* background-color: #e50000; */\n  margin-bottom:0px;\n/*   color:white; */\n}\n\n\n\n.leftPaneAdd {\n  max-width:25%;\n  flex:0 0 25%;\n  padding-left:8px;\n  padding-right:10px;\n  min-height: 4rem;\n}\n\n.leftPanelContentadd {\n  width:94%;\n  height:100%;\n  display:inline-block;\n}\n\n.toogleSwitch-toyota{\n  background-image: url(\"../../assets/images/collapsebtn-toyota.png\");\n  background-color: white; \n  height: 100%;\n  cursor: pointer;\n  width:14px;\n  background-repeat: no-repeat;\n  /* margin-left:5px; */\n  border:solid 1px #ececec;\n  background-position: center;\n}\n.toogleSwitch-lexus{\n  background-image: url(\"../../assets/images/collapsebtn-lexus.png\");\n  background-color: white; \n  height: 100%;\n  cursor: pointer;\n  width:14px;\n  background-repeat: no-repeat;\n  /* margin-left:5px; */\n  border:solid 1px #ececec;\n  background-position: center;\n \n}\n\n.addEditPadding{\n  padding-top: 2rem !important;\n}\n.collapsed{\n  padding-top: 2rem !important;\n  display: none !important;\n}\n.collapseAddEdit{\n  height: 100%;\n  /* padding-left: .4rem; */\n}\n\n.addEditToolboxRemove-toyota {\n  border-left: solid #e50000 0.375rem;\n  /* margin: 0.375rem !important; */\n  margin-top: 0.375rem !important;\n  height: 5rem;\n  -ms-flex-align: center;\n  align-items: center;\n  width:7.5rem;\n  border-radius: 0px 20px 20px 0px;\n}\n.addEditToolboxRemove-lexus {\n  border-left: solid black 0.375rem;\n  /* margin: 0.375rem !important; */\n  margin-top: 0.375rem !important;\n  height: 5rem;\n  -ms-flex-align: center;\n  align-items: center;\n  width:7.5rem;\n  border-radius: 0px 20px 20px 0px;\n}\n\n.kpiTableContainer .nav-link{\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n/* .container-fluid .libraryContainer .button-toyota{\n  bottom: 38px;\n  position: absolute;\n} */\n/* .rightPanel.libRightPanel{\n  position:relative; \n} */\n.kpiTableContainer.tab-content{\n  min-height: 779px;\n }\n/* .kpiTableContainer.nmscTable{\n  min-height: 779px;\n} */\n/* .tab-content.nmscTable{\n min-height: 3rem;\n} */\n\n\n.selectField{\n  width: 95%;\n  margin-bottom: 5%;\n}\n.selectFieldDisplay{\n  width: 95%;\n  margin-bottom: 5%;\n  display: none\n}\n.marginTop{\n  margin-top: -12% !important;\n  margin-right: -1% !important;\n}\n \n/* .modal {\n  display: block !important;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
